import { Component, EventEmitter, input, Output, computed, effect } from '@angular/core';
import { ButtonComponent } from "../../base";
import { FormGridComponent, FormSectionComponent } from "../../layouts";
import { FormGroup, FormsModule, NonNullableFormBuilder, ReactiveFormsModule, Validators } from "@angular/forms";
import { CheckboxComponent, TextInputComponent } from "../../form-inputs";
import { OtpConfig, OtpLogin } from "shared";

@Component({
  selector: 'lib-signup-form',
  standalone: true,
  imports: [
    ButtonComponent,
    FormGridComponent,
    FormsModule,
    ReactiveFormsModule,
    TextInputComponent,
    FormSectionComponent,
    CheckboxComponent
  ],
  templateUrl: './signup-form.component.html',
  styleUrl: './signup-form.component.css'
})
export class SignupFormComponent {
  public otpConfig = input.required<OtpConfig | undefined>();

  @Output() signup = new EventEmitter<OtpLogin>();

  signupForm: FormGroup;
  showFormErrors: boolean = false;

  protected hasTermsOrPrivacy = computed(() => {
    const config = this.otpConfig();
    return !!(config?.liabilityDisclaimer || config?.privacyPolicy);
  });

  constructor(fb: NonNullableFormBuilder) {
    this.signupForm = fb.group({
      name: ['', { validators: Validators.required }],
      surname: ['', { validators: Validators.required }],
      email: ['', { validators: [Validators.required, Validators.email] }],
      termsAndConditions: [false],
    });

    effect(() => {
      const termsControl = this.signupForm.get('termsAndConditions');
      if (termsControl) {
        if (this.hasTermsOrPrivacy()) {
          termsControl.setValidators(Validators.requiredTrue);
        } else {
          termsControl.clearValidators();
        }
        termsControl.updateValueAndValidity();
      }
    });
  }

  submit() {
    if (this.signupForm.invalid) {
      this.showFormErrors = true;
    } else {
      this.signup.emit(this.signupForm.value);
    }
  }
}
